<div class="n-breadcrumb d-flex align-items-center justify-content-between">
    <ol class="breadcrumb m-0 bg-transparent p-0">
        <li class="breadcrumb-item"><a href="/#/dealer/home">Home</a></li>
        <!-- <li class="breadcrumb-item"><a href="/#/dealer/home">Manage Dealers</a></li> -->
        <li class="breadcrumb-item active">{{pageTitle}}</li>
    </ol>
</div>

<h3 class="mt-4 font-weight-light">{{pageTitle}}</h3>

<div class="tcard">
    <div class="tcard-body p-4">
        <div class="col-md-121 ">
            <form class="" novalidate [formGroup]="listuploadForm">
                <div class="row">
                    <div class="col-md-12">
                        <div class="col-md-6 mb-3">
                            <label>List Name</label>
                            <input type="text" class="form-control" formControlName="ListName" [(ngModel)]="ListName">
                        </div>
                    </div>
                    <div class=" col-md-12">
                        <div class="col-md-6 mb-3 form-group">
                            <label>List File</label>
                            <input type="file" formControlName="ListFile" class="form-control" (change)="selectFile($event)">
                        </div>
                    </div>
                    <!-- <div class=" col-md-12">
                        <div class="col-md-6 mb-3">
                            <button type="submit" class="btn btn-success" [disabled]="!selectedFiles"
                                (click)="upload()">Upload</button>
                        </div>
                    </div> -->
                   
                </div>
                <div class="text-right">
                    <label *ngIf="error" style="color: rgb(235, 35, 0);margin-right: 15px;">{{msgError}} </label>
                    <label *ngIf="success" style="color: green;margin-right: 15px;"> {{msgSuccess}}</label>
                    <button type="submit" class="ml-2 btn btn-primary  py-2 px-4" [disabled]="!selectedFiles"
                            (click)="upload()"><i class="la la-check mr-2"></i>Save</button>
                    <!-- <button type="submit" class=" ml-2 btn btn-primary  py-2 px-4" (click)="upload()" [disabled]='!listuploadForm.valid'><i class="la la-check mr-2"></i>Upload</button> -->
                </div>
            </form>
        </div>
    </div>
</div>